import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import ExpandableModalPanel from 'components/consumer/ExpandableModalPanel';
import ShopByHeaderSection from 'components/consumer/ShopByHeaderSection';
import IconCheck from 'components/icons/iconCheck';
const ExpandableModalOptions = t0 => {
  const $ = _c(11);
  const {
    isOpen,
    label: groupLabel,
    onClose,
    options
  } = t0;
  let t1;
  if ($[0] !== options) {
    t1 = options.map(_temp);
    $[0] = options;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <div className="text-base font-bold text-gray flex flex-col mx-0 my-[5px] w-full">{t1}</div>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== groupLabel || $[5] !== t2) {
    t3 = <div className="pl-[3.333vw] pr-[3.333vw] [border-bottom:1px_solid_#f1f1f1]"><div className="flex-wrap pt-4 px-0 pb-0 md:items-start md:flex md:min-h-[100px] md:mt-0 md:mb-0"><ShopByHeaderSection label={groupLabel}>{t2}</ShopByHeaderSection></div></div>;
    $[4] = groupLabel;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== isOpen || $[8] !== onClose || $[9] !== t3) {
    t4 = <ExpandableModalPanel isOpen={isOpen} onOverlayClick={onClose}>{t3}</ExpandableModalPanel>;
    $[7] = isOpen;
    $[8] = onClose;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
};
ExpandableModalOptions.propTypes = {
  isOpen: PropTypes.bool,
  label: PropTypes.string,
  onClose: PropTypes.func,
  options: PropTypes.arrayOf(PropTypes.shape({
    map: PropTypes.func,
    label: PropTypes.string,
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    isSelected: PropTypes.bool,
    onClick: PropTypes.func
  }))
};
export default ExpandableModalOptions;
function _temp(t0) {
  const {
    label,
    id,
    isSelected,
    onClick
  } = t0;
  return <button type="button" className="p-2.5 flex items-start justify-start bg-white border-0 text-black" key={id} onClick={onClick}>{label}{" "}{isSelected ? <IconCheck className="h-[.9rem] ml-4 w-[.9rem] [&_path]:stroke-[#107c8c]" color="#27919C" /> : ""}</button>;
}